export default {
  receivePay_getReceivePayListByPage: {
    type: 'post'
  },
  receivePay_exportReceivePayList: {
    type: 'get'
  },
  receivePay_exportReceivePayByPage: {
    type: 'blobPost'
  },
  receivePay_refreshAndCallback: {
    type: 'formDataPost'
  },
  receivePay_getBankTradeReceivePayData:{
    type: 'formDataPost'
  }
}



// WEBPACK FOOTER //
// ./src/service/modules/collectionList.js